import MicroserviceTypes from './microservice-types';

const MicroServiceRuleIds = {
  WORKFLOW_V4_LIST: 'workflow-v4-list',
  WORKFLOW_V4_CLONE: 'workflow-v4-clone',
  WORKFLOW_V4_DELETE: 'workflow-v4-delete',
  WORKFLOW_V4_CREATE: 'workflow-v4-create',
  WORKFLOW_V4_GET: 'workflow-v4-get',
  WORKFLOW_V4_ARCHIVE: 'workflow-v4-archive',
  WORKFLOW_V4_GET_TEMPLATE: 'workflow-v4-get-template',
  WORKFLOW_V4_GET_SCHEMA: 'workflow-v4-get-schema',
  WORKFLOW_V4_GET_RULE: 'workflow-v4-get-rule',
  TEMPLATE_V4_LIST: 'template-v4-list',
  TEMPLATE_V4_CREATE: 'template-v4-create',
  WORKFLOW_V4_GET_CONFIG: 'workflow-v4-get-config',
  EXCEL_GET_TEMPLATE: 'excel-get-template',
  EXCEL_UPLOAD_FILE: 'excel-upload-file',
  EXCEL_UPDATE_MAPPING: 'excel-update-mapping',
  EXCEL_GET_AUTHORIZED_USERS: 'excel-get-authorized-users',
  LIST_USERS: 'list-users',
  EXCEL_UPDATE_AUTHORIZED_USERS: 'excel-update-authorized-users',
  CUSTOM_FIELDS_LIST: 'custom-fields-list',
  CUSTOM_FIELDS_CREATE: 'custom-fields-create',
  CUSTOM_FIELDS_DELETE: 'custom-fields-delete',
  CUSTOM_FIELDS_UPDATE: 'custom-fields-edit',
  TEMPLATE_V4_UPDATE: 'template-v4-update',
  TEMPLATE_V4_DELETE: 'template-v4-delete',
  TEMPLATE_V4_GET: 'template-v4-get',
  TEMPLATE_V4_GET_FORM_FIELDS: 'template-v4-get-form-fields',
  TEMPLATE_V4_GENERATE_DOCUMENT: 'template-v4-generate-document',
  REPORT_READ_REPORT: 'report-read-report',
  REPORT_ORG_SCHEDULE_REPORT: 'report-org-schedule-report',
  REPORT_ORG_TRIGGER_REPORT: 'report-org-trigger-report',
  AUTH_CREATE_OAUTH2_WEB_SERVER_CLIENT: 'auth-create-oauth2-web-server-client',
  AUTH_CREATE_OAUTH2_SERVICE_CLIENT: 'auth-create-oauth2-service-client',
  AUTH_CREATE_OAUTH2_SELF_CLIENT: 'auth-create-oauth2-self-client',
  AUTH_CREATE_OAUTH2_ANY_CLIENT: 'auth-create-oauth2-any-client',
  AUTH_CREATE_INVITATION: 'auth-create-invitation',

  // Automation, served by @leegality/sequence-automation. One id per
  // permission the package exposes.
  AUTOMATION_SEARCH_SEQUENCE: 'automation-search-sequence',
  AUTOMATION_READ_SEQUENCE: 'automation-read-sequence',
  AUTOMATION_CREATE_SEQUENCE: 'automation-create-sequence',
  AUTOMATION_UPDATE_SEQUENCE: 'automation-update-sequence',
  AUTOMATION_PUBLISH_SEQUENCE: 'automation-publish-sequence',
  AUTOMATION_ARCHIVE_SEQUENCE: 'automation-archive-sequence',
  AUTOMATION_IMPORT_SEQUENCE: 'automation-import-sequence',
  AUTOMATION_EXPORT_SEQUENCE: 'automation-export-sequence',
  AUTOMATION_EXECUTE_SEQUENCE: 'automation-execute-sequence',
  AUTOMATION_SEARCH_EVENT: 'automation-search-event',
  AUTOMATION_READ_EVENT: 'automation-read-event',
  AUTOMATION_CREATE_EVENT: 'automation-create-event',
  AUTOMATION_UPDATE_EVENT: 'automation-update-event',
  AUTOMATION_ARCHIVE_EVENT: 'automation-archive-event',
  AUTOMATION_IMPORT_EVENT: 'automation-import-event',
  AUTOMATION_EXPORT_EVENT: 'automation-export-event',
  AUTOMATION_SEARCH_EVENT_RECORD: 'automation-search-event-record',
  AUTOMATION_LIST_CONNECTOR: 'automation-list-connector',
  AUTOMATION_CREATE_CONNECTOR: 'automation-create-connector',
  AUTOMATION_UPDATE_CONNECTOR: 'automation-update-connector',
  AUTOMATION_DELETE_CONNECTOR: 'automation-delete-connector',
  AUTOMATION_LIST_CREDENTIAL: 'automation-list-credential',
  AUTOMATION_CREATE_CREDENTIAL: 'automation-create-credential',
  AUTOMATION_UPDATE_CREDENTIAL: 'automation-update-credential',
  AUTOMATION_DELETE_CREDENTIAL: 'automation-delete-credential',
  AUTOMATION_SEARCH_ACTIVITY_LOG: 'automation-search-activity-log',
  LEE_AI_START_CONVERSATION: 'lee-ai-start-conversation',
};

const MSRAccessors = {
  WORKFLOW_V4_LIST_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.listWorkflows`,
  WORKFLOW_V4_DELETE_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.deleteWorkflow`,
  WORKFLOW_V4_CREATE_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.createWorkflow`,
  WORKFLOW_V4_GET_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.getWorkflow`,
  WORKFLOW_V4_CLONE_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.cloneWorkflow`,
  WORKFLOW_V4_ARCHIVE_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.updateWorkflowStatusArchive`,
  WORKFLOW_V4_GET_TEMPLATE_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.getWorkflowTemplate`,
  WORKFLOW_V4_GET_SCHEMA_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.getSchema`,
  WORKFLOW_V4_GET_RULE_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.getWorkflowRule`,
  TEMPLATE_V4_LIST_ACCESSOR: `${MicroserviceTypes.TEMPLATE}.listTemplates`,
  TEMPLATE_V4_CREATE_ACCESSOR: `${MicroserviceTypes.TEMPLATE}.createTemplate`,
  WORKFLOW_V4_GET_CONFIG_ACCESSOR: `${MicroserviceTypes.DIS}.getWorkflowConfig`,
  EXCEL_GET_TEMPLATE_ACCESSOR: `${MicroserviceTypes.DIS}.getExcelTemplate`,
  EXCEL_UPLOAD_FILE_ACCESSOR: `${MicroserviceTypes.DIS}.uploadExcel`,
  EXCEL_UPDATE_MAPPING_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.updateExcelMapping`,
  EXCEL_GET_AUTHORIZED_USERS_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.getExcelAuthorizedUsers`,
  LIST_USERS_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.listUsers`,
  EXCEL_UPDATE_AUTHORIZED_USERS_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.updateExcelAuthorizedUsers`,
  CUSTOM_FIELDS_LIST_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.listCustomFields`,
  CUSTOM_FIELDS_CREATE_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.createCustomField`,
  CUSTOM_FIELDS_DELETE_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.deleteCustomField`,
  CUSTOM_FIELDS_UPDATE_ACCESSOR: `${MicroserviceTypes.WORKFLOW_MANAGER}.updateCustomField`,
  TEMPLATE_V4_UPDATE_ACCESSOR: `${MicroserviceTypes.TEMPLATE}.updateTemplate`,
  TEMPLATE_V4_DELETE_ACCESSOR: `${MicroserviceTypes.TEMPLATE}.deleteTemplate`,
  TEMPLATE_V4_GET_ACCESSOR: `${MicroserviceTypes.TEMPLATE}.getTemplate`,
  TEMPLATE_V4_GET_FORM_FIELDS_ACCESSOR: `${MicroserviceTypes.TEMPLATE}.getFormFields`,
  TEMPLATE_V4_GENERATE_DOCUMENT_ACCESSOR: `${MicroserviceTypes.TEMPLATE}.generateDocument`,
  REPORT_READ_REPORT_ACCESSOR: `${MicroserviceTypes.REPORT}.listReport`,
  REPORT_ORG_SCHEDULE_REPORT_ACCESSOR: `${MicroserviceTypes.REPORT}.scheduleReport`,
  REPORT_ORG_TRIGGER_REPORT_ACCESSOR: `${MicroserviceTypes.REPORT}.triggerReport`,
  AUTH_CREATE_OAUTH2_WEB_SERVER_CLIENT_ACCESSOR: `${MicroserviceTypes.AUTH}.createOAuth2WebServerClient`,
  AUTH_CREATE_OAUTH2_SERVICE_CLIENT_ACCESSOR: `${MicroserviceTypes.AUTH}.createOAuth2ServiceClient`,
  AUTH_CREATE_OAUTH2_SELF_CLIENT_ACCESSOR: `${MicroserviceTypes.AUTH}.createOAuth2SelfClient`,
  AUTH_CREATE_INVITATION_ACCESSOR: `${MicroserviceTypes.AUTH}.createInvitation`,

  // Automation. These accessor strings are the entitlement names the backend
  // already issues; CMF consumes the same set.
  AUTOMATION_SEARCH_SEQUENCE_ACCESSOR: `${MicroserviceTypes.SEQUENCE_MANAGER}.searchSequence`,
  AUTOMATION_READ_SEQUENCE_ACCESSOR: `${MicroserviceTypes.SEQUENCE_MANAGER}.readSequence`,
  AUTOMATION_CREATE_SEQUENCE_ACCESSOR: `${MicroserviceTypes.SEQUENCE_MANAGER}.createSequence`,
  AUTOMATION_UPDATE_SEQUENCE_ACCESSOR: `${MicroserviceTypes.SEQUENCE_MANAGER}.updateSequence`,
  AUTOMATION_PUBLISH_SEQUENCE_ACCESSOR: `${MicroserviceTypes.SEQUENCE_MANAGER}.publishSequence`,
  AUTOMATION_ARCHIVE_SEQUENCE_ACCESSOR: `${MicroserviceTypes.SEQUENCE_MANAGER}.archiveSequence`,
  AUTOMATION_IMPORT_SEQUENCE_ACCESSOR: `${MicroserviceTypes.SEQUENCE_MANAGER}.importSequence`,
  AUTOMATION_EXPORT_SEQUENCE_ACCESSOR: `${MicroserviceTypes.SEQUENCE_MANAGER}.exportSequence`,
  AUTOMATION_EXECUTE_SEQUENCE_ACCESSOR: `${MicroserviceTypes.SEQUENCE_MANAGER}.executeSequence`,
  AUTOMATION_SEARCH_EVENT_ACCESSOR: `${MicroserviceTypes.EVENT_SERVICE}.searchEvent`,
  AUTOMATION_READ_EVENT_ACCESSOR: `${MicroserviceTypes.EVENT_SERVICE}.readEvent`,
  AUTOMATION_CREATE_EVENT_ACCESSOR: `${MicroserviceTypes.EVENT_SERVICE}.createEvent`,
  AUTOMATION_UPDATE_EVENT_ACCESSOR: `${MicroserviceTypes.EVENT_SERVICE}.updateEvent`,
  AUTOMATION_ARCHIVE_EVENT_ACCESSOR: `${MicroserviceTypes.EVENT_SERVICE}.archiveEvent`,
  AUTOMATION_IMPORT_EVENT_ACCESSOR: `${MicroserviceTypes.EVENT_SERVICE}.importEvent`,
  AUTOMATION_EXPORT_EVENT_ACCESSOR: `${MicroserviceTypes.EVENT_SERVICE}.exportEvent`,
  AUTOMATION_SEARCH_EVENT_RECORD_ACCESSOR: `${MicroserviceTypes.EVENT_SERVICE}.searchRecord`,
  AUTOMATION_LIST_CONNECTOR_ACCESSOR: `${MicroserviceTypes.RULE_ENGINE}.listConnector`,
  AUTOMATION_CREATE_CONNECTOR_ACCESSOR: `${MicroserviceTypes.RULE_ENGINE}.createConnector`,
  AUTOMATION_UPDATE_CONNECTOR_ACCESSOR: `${MicroserviceTypes.RULE_ENGINE}.updateConnector`,
  AUTOMATION_DELETE_CONNECTOR_ACCESSOR: `${MicroserviceTypes.RULE_ENGINE}.deleteConnector`,
  AUTOMATION_LIST_CREDENTIAL_ACCESSOR: `${MicroserviceTypes.RULE_ENGINE}.listCredential`,
  AUTOMATION_CREATE_CREDENTIAL_ACCESSOR: `${MicroserviceTypes.RULE_ENGINE}.createCredential`,
  AUTOMATION_UPDATE_CREDENTIAL_ACCESSOR: `${MicroserviceTypes.RULE_ENGINE}.updateCredential`,
  AUTOMATION_DELETE_CREDENTIAL_ACCESSOR: `${MicroserviceTypes.RULE_ENGINE}.deleteCredential`,
  AUTOMATION_SEARCH_ACTIVITY_LOG_ACCESSOR: `${MicroserviceTypes.ACTIVITY_LOGGING_WORKER}.searchActivityLog`,
  LEE_AI_START_CONVERSATION_ACCESSOR: `${MicroserviceTypes.LEE_AI}.startConversation`,
};

// This will be removed once we move fully to micro service
const MSRules = {
  [MicroServiceRuleIds.WORKFLOW_V4_LIST]: (map) => map[MicroServiceRuleIds.WORKFLOW_V4_LIST],
  [MicroServiceRuleIds.WORKFLOW_V4_CLONE]: (map) => map[MicroServiceRuleIds.WORKFLOW_V4_CLONE],
  [MicroServiceRuleIds.WORKFLOW_V4_DELETE]: (map) => map[MicroServiceRuleIds.WORKFLOW_V4_DELETE],
  [MicroServiceRuleIds.WORKFLOW_V4_CREATE]: (map) => map[MicroServiceRuleIds.WORKFLOW_V4_CREATE],
  [MicroServiceRuleIds.WORKFLOW_V4_GET]: (map) => map[MicroServiceRuleIds.WORKFLOW_V4_GET],
  [MicroServiceRuleIds.WORKFLOW_V4_ARCHIVE]: (map) => map[MicroServiceRuleIds.WORKFLOW_V4_ARCHIVE],
  [MicroServiceRuleIds.WORKFLOW_V4_GET_TEMPLATE]: (map) => (
    map[MicroServiceRuleIds.WORKFLOW_V4_GET_TEMPLATE]
  ),
  [MicroServiceRuleIds.WORKFLOW_V4_GET_SCHEMA]: (map) => (
    map[MicroServiceRuleIds.WORKFLOW_V4_GET_SCHEMA]
  ),
  [MicroServiceRuleIds.WORKFLOW_V4_GET_RULE]: (map) => (
    map[MicroServiceRuleIds.WORKFLOW_V4_GET_RULE]
  ),
  [MicroServiceRuleIds.TEMPLATE_V4_LIST]: (map) => (
    map[MicroServiceRuleIds.TEMPLATE_V4_LIST]
  ),
  [MicroServiceRuleIds.TEMPLATE_V4_CREATE]: (map) => (
    map[MicroServiceRuleIds.TEMPLATE_V4_CREATE]
  ),
  [MicroServiceRuleIds.WORKFLOW_V4_GET_CONFIG]: (map) => (
    map[MicroServiceRuleIds.WORKFLOW_V4_GET_CONFIG]
  ),
  [MicroServiceRuleIds.CUSTOM_FIELDS_LIST]: (map) => (
    map[MicroServiceRuleIds.CUSTOM_FIELDS_LIST]
  ),
  [MicroServiceRuleIds.CUSTOM_FIELDS_CREATE]: (map) => (
    map[MicroServiceRuleIds.CUSTOM_FIELDS_CREATE]
  ),
  [MicroServiceRuleIds.CUSTOM_FIELDS_DELETE]: (map) => (
    map[MicroServiceRuleIds.CUSTOM_FIELDS_DELETE]
  ),
  [MicroServiceRuleIds.CUSTOM_FIELDS_UPDATE]: (map) => (
    map[MicroServiceRuleIds.CUSTOM_FIELDS_UPDATE]
  ),
  [MicroServiceRuleIds.TEMPLATE_V4_CREATE]: (map) => (
    !!map[MicroServiceRuleIds.TEMPLATE_V4_CREATE]
  ),
  [MicroServiceRuleIds.TEMPLATE_V4_UPDATE]: (map) => (
    !!map[MicroServiceRuleIds.TEMPLATE_V4_UPDATE]
  ),
  [MicroServiceRuleIds.TEMPLATE_V4_DELETE]: (map) => (
    !!map[MicroServiceRuleIds.TEMPLATE_V4_DELETE]
  ),
  [MicroServiceRuleIds.TEMPLATE_V4_GET]: (map) => (
    !!map[MicroServiceRuleIds.TEMPLATE_V4_GET]
  ),
  [MicroServiceRuleIds.TEMPLATE_V4_LIST]: (map) => (
    !!map[MicroServiceRuleIds.TEMPLATE_V4_LIST]
  ),
  [MicroServiceRuleIds.TEMPLATE_V4_GET_FORM_FIELDS]: (map) => (
    !!map[MicroServiceRuleIds.TEMPLATE_V4_GET_FORM_FIELDS]
  ),
  [MicroServiceRuleIds.TEMPLATE_V4_GENERATE_DOCUMENT]: (map) => (
    !!map[MicroServiceRuleIds.TEMPLATE_V4_GENERATE_DOCUMENT]
  ),
  [MicroServiceRuleIds.REPORT_READ_REPORT]: (map) => (
    !!map[MicroServiceRuleIds.REPORT_READ_REPORT]
  ),
  [MicroServiceRuleIds.REPORT_ORG_SCHEDULE_REPORT]: (map) => (
    !!map[MicroServiceRuleIds.REPORT_ORG_SCHEDULE_REPORT]
  ),
  [MicroServiceRuleIds.REPORT_ORG_TRIGGER_REPORT]: (map) => (
    !!map[MicroServiceRuleIds.REPORT_ORG_TRIGGER_REPORT]
  ),
  [MicroServiceRuleIds.AUTH_CREATE_OAUTH2_ANY_CLIENT]: (map) => !!(
    map[MicroServiceRuleIds.AUTH_CREATE_OAUTH2_WEB_SERVER_CLIENT]
    || map[MicroServiceRuleIds.AUTH_CREATE_OAUTH2_SERVICE_CLIENT]
    || map[MicroServiceRuleIds.AUTH_CREATE_OAUTH2_SELF_CLIENT]
  ),
  [MicroServiceRuleIds.AUTH_CREATE_INVITATION]: (map) => (
    !!map[MicroServiceRuleIds.AUTH_CREATE_INVITATION]
  ),
  [MicroServiceRuleIds.EXCEL_GET_TEMPLATE]: (map) => (
    !!map[MicroServiceRuleIds.EXCEL_GET_TEMPLATE]
  ),
  [MicroServiceRuleIds.EXCEL_UPLOAD_FILE]: (map) => (
    !!map[MicroServiceRuleIds.EXCEL_UPLOAD_FILE]
  ),
  [MicroServiceRuleIds.EXCEL_UPDATE_MAPPING]: (map) => (
    !!map[MicroServiceRuleIds.EXCEL_UPDATE_MAPPING]
  ),
  [MicroServiceRuleIds.EXCEL_GET_AUTHORIZED_USERS]: (map) => (
    !!map[MicroServiceRuleIds.EXCEL_GET_AUTHORIZED_USERS]
  ),
  [MicroServiceRuleIds.LIST_USERS]: (map) => !!map[MicroServiceRuleIds.LIST_USERS],
  [MicroServiceRuleIds.EXCEL_UPDATE_AUTHORIZED_USERS]: (map) => (
    !!map[MicroServiceRuleIds.EXCEL_UPDATE_AUTHORIZED_USERS]
  ),
};

export {
  MSRules, MSRAccessors, MicroServiceRuleIds,
};
